import { Injectable } from '@angular/core';
import { OrigamiResponse, ServiceBase } from '@app/origami-api/services/base/service.base';
import { Observable } from 'rxjs';

export namespace ServerTaskQueue {
  export enum ServerTaskQueueStatus {
    Pending = 1,
    InProgress = 2,
    Completed = 3,
    Failed = 4,
  }

  export enum ServerTaskQueueType {
    ExportDocuments = 1,
    ExportDataroomArchive = 2,
    ExportDataroomArchiveStandard = 3,
    ExportFolderArchive = 4,
    ExportEssentialDocuments = 5,
  }

  export enum UploadExportType {
    None = 0,
    UserExport,
    ArchiveExport,
  }

  export interface GetExportProcessingOptions {
    StartIndex?: number;
    Limit?: number;
    SortBy?: string; // Field to sort the results by. Possible values: "room", "user", "exporttype", "status"
    SortByDesc?: boolean;
    FilterBy?: string; // Field to filter the results by. Possible values: NOT AVAILABLE
    FilterValue?: string;
  }

  export interface GetDownloadUrlOptions {
    siteId: number;
    serverTaskQueueId: number;
  }

  export interface GetExportPasswordOptions {
    siteId: number;
    serverTaskQueueId: number;
  }

  export interface ExportProcessingResult {
    Total: number;
    Records: ExportProcessing[];
  }

  export interface ExportProcessing {
    CreatedDate: string;
    ExportResults: ExportResults;
    ProgressCurrent: number;
    ProgressTotal: number;
    RoomId: number;
    RoomName: string;
    FullName: string;
    EmailAddress: string;
    ServerTaskQueueId: number;
    ServerTaskQueueTaskTypeId: ServerTaskQueueType;
    StatusId: ServerTaskQueueStatus;
    UserId?: number;
    HasDownloadLink: boolean;
    HasPassword: boolean;
  }

  export interface ExportResults {
    ArchiveExport: ArchiveExport;
    DocumentArchiveSize: number;
    ExpirationDate: string;
    IsExpired: boolean;
    UserExport: UserExport;
    UploadExportType: UploadExportType;
  }

  export interface UserExport {
    Password: string;
  }

  export interface ArchiveExport {
    FilePath: string;
  }
}

@Injectable({ providedIn: 'root' })
export class ServerTaskQueueService extends ServiceBase {
  serviceUrl = 'ServerTaskQueueService.svc';

  public getExportProcessing(
    body: ServerTaskQueue.GetExportProcessingOptions,
  ): Observable<OrigamiResponse<ServerTaskQueue.ExportProcessingResult>> {
    return this.origamiPost('/GetServerTaskQueue', body, null, null, true);
  }

  public getDownloadUrl(body: ServerTaskQueue.GetDownloadUrlOptions): Observable<OrigamiResponse<string>> {
    return this.origamiPost('/GetDownloadUrl', body, null, null, true);
  }

  public getExportPassword(body: ServerTaskQueue.GetExportPasswordOptions): Observable<OrigamiResponse<string>> {
    return this.origamiPost('/GetExportPassword', body, null, null, true);
  }
}
